import React from 'react'
import TransferDetaillView from '../../../containers/Inventory/transfer/TransferDetaillView'

const TransferDetaill = ({ match }) => {
    const products = [
        {
            code: "231212213",
            name: "Jabon",
            batch: "12312312",
            unit_price: 1000,
            quantity: 5
        },
        {
            code: "331211213",
            name: "Shampu",
            batch: "12312312",
            unit_price: 1000,
            quantity: 8
        },
        {
            code: "211212213",
            name: "Acondicionaddor",
            batch: "12312312",
            unit_price: 1000,
            quantity: 2
        },
    ]
    const transfers = [
        { date: "20/01/2021", type: "Transferencia", origin: "Bodega 1", destiny: "Almacen 1", _id: "544312" },
    ]
    return (
        <TransferDetaillView products={products} />
    )
}

export default TransferDetaill
